import { Injectable } from "@angular/core";
import { LocalStorageService } from "angular-2-local-storage";

@Injectable()
export class StorageRef {
    constructor(private storage: LocalStorageService) { }

    public set(key: string, value: any): boolean {
        return this.storage.set(key, value);
    }

    public get(key: string): any {
        return this.storage.get(key);
    }

    public reset(): boolean {
        return this.storage.clearAll();
    }

    public unset(key: string): boolean {
        return this.storage.remove(key);
    }

    public unsetMany(keys: string[]): boolean {
        return this.storage.remove(...keys);
    }
}
